export default "__VITE_ASSET__C07wFM0___"